<input type="text" [(ngModel)]="username">
<input type="text" [(ngModel)]="password">
<button (click)="adduser()"> submit</button>
<button (click)="loginuser()"> login</button>